import { Modal, Select, Input, Radio, Tooltip } from "antd";
import { Check } from "react-feather";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { SetStateAction, useEffect, useState } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { permissionAPI, roleAPI } from "@api";
import { MODAL_PERMISSION_ADD, MODAL_PERMISSION_EDIT, MODAL_PERMISSION_INFO } from "@configs";
import { ModuleButtonAction } from "@modules";
import { useAppDispatch, openToast } from "@redux";
import { IRole } from "@interfaces";
interface IProps {
    visible: boolean;
    typeModal: number;
    handleClose: (callback?: boolean) => void;
    handleDelete: (userId: string | undefined) => void;
    permissionTitle: { title: string; type: string }[];
    userId?: string;
    currentRole: {
        roleId: string;
        name: string;
    };
}

const activeIcon = (
    <Check
        color={"white"}
        size={22}
        style={{ background: "#0263E0", borderRadius: 100, padding: 4 }}
    />
);
export const ModalPermissionComponent = (props: IProps) => {
    useEffect(() => {
        getListRole();
    }, []);
    //page hook
    const { t } = useTranslation();
    // page state
    const [valueSelect, setValueSelect] = useState<string>("");
    const [messCopied, setMessCopied] = useState(t("page._copy"));
    const [listRole, setListRole] = useState<IRole[]>([]);
    const [linkSignup, setLinkSignup] = useState("");
    const dispatch = useAppDispatch();
    //page variable
    const { permissionTitle, userId, currentRole } = props;
    const handleSelect = (value: string) => {
        setValueSelect(value);
        getInviteLink(value);
    };
    const getInviteLink = async (value: string) => {
        try {
            const response = await roleAPI.createInviteLink({ roleId: value });
            if (response.status === 200 && response.statusText === "OK") {
                setLinkSignup(`${window.location.host}/sign-up/${response.data.inviteId}`);
            } else {
                dispatch(
                    openToast({
                        message: t("message.try_again_text"),
                        type: "error",
                        autoHideDuration: 2000,
                    })
                );
            }
        } catch (err: any) {
            if (err.response) {
                const mess = Array.isArray(err.response.data.errors)
                    ? err.response.data.errors[0]
                    : err.response.data.errors;
                dispatch(
                    openToast({
                        message: mess,
                        type: "error",
                        autoHideDuration: 2000,
                    })
                );
            } else
                dispatch(
                    openToast({
                        message: t("message.error"),
                        type: "error",
                        autoHideDuration: 2000,
                    })
                );
        }
    };
    const getListRole = async () => {
        const response = await roleAPI.getList();

        setListRole(response.data);
    };
    const updateRole = async (value: string) => {
        const params = { roleId: value };
        if (userId)
            try {
                const response = await permissionAPI.updateRole(userId, params);
                if (response.status === 200) {
                    dispatch(
                        openToast({
                            message: t("message.update.success", {
                                returnObjects: true,
                                name: "role",
                            }),
                            type: "success",
                            autoHideDuration: 2000,
                        })
                    );
                    props.handleClose(true);
                } else
                    dispatch(
                        openToast({
                            message: t("message.update.fail", {
                                returnObjects: true,
                                name: "role",
                            }),
                            type: "success",
                            autoHideDuration: 2000,
                        })
                    );
            } catch (err: any) {
                if (err.response) {
                    const mess = Array.isArray(err.response.data.errors)
                        ? err.response.data.errors[0]
                        : err.response.data.errors;
                    dispatch(
                        openToast({
                            message: mess,
                            type: "error",
                            autoHideDuration: 2000,
                        })
                    );
                } else
                    dispatch(
                        openToast({
                            message: t("message.error"),
                            type: "error",
                            autoHideDuration: 2000,
                        })
                    );
            }
    };

    const copyClipBoard = () => {
        navigator.clipboard.writeText(linkSignup);
        setMessCopied(t("page._copied"));
        setTimeout(() => setMessCopied(t("page._copy")), 5000);
    };
    const handleDelete = () => {
        Modal.confirm({
            title: t("message.delete_title"),
            icon: <ExclamationCircleOutlined />,
            content: t("message.delete_confirm"),
            okText: t("page.action.delete"),
            cancelText: t("page.action.cancel"),
            centered: true,
            onOk: () => props.handleDelete(userId),
        });
    };
    const { Option } = Select;
    const actionField = (type: number) => {
        switch (type) {
            case MODAL_PERMISSION_INFO:
                return (
                    <div
                        className="wrap-btn"
                        style={{ display: "flex", justifyContent: "center", marginTop: 40 }}
                    >
                        <ModuleButtonAction
                            className="submit-btn"
                            type="primary"
                            text={t("page.action.close")}
                            onClick={() => props.handleClose()}
                        />
                    </div>
                );
            case MODAL_PERMISSION_ADD:
                return (
                    <div
                        className="wrap-btn"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            marginTop: 24,
                            paddingTop: 24,
                            borderTop: "1px #A5A5A5 solid",
                        }}
                    >
                        <p style={{ alignSelf: "start" }}>
                            {t("page.permission.grant_members_permissions_via_direct_URL_links")}
                        </p>
                        <div style={{ width: "100%" }}>
                            <Select
                                style={{ width: "90%", height: 48, margin: "8px 0px" }}
                                placeholder={t("page.permission.choose_permission")}
                                onChange={handleSelect}
                            >
                                {listRole &&
                                    listRole.map((item) => {
                                        return (
                                            <Option key={item._id} value={item._id}>
                                                <Radio
                                                    checked={valueSelect === item._id}
                                                    value={item._id}
                                                >
                                                    {item.name}
                                                </Radio>
                                            </Option>
                                        );
                                    })}
                            </Select>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Input
                                    placeholder={t(
                                        "page.permission.choose_permission_and_copy_link"
                                    )}
                                    value={linkSignup}
                                    style={{
                                        height: 48,
                                        backgroundColor: "#F7F7F8",
                                        margin: "8px 12px 8px 0px",
                                        width: "90%",
                                        cursor: "auto",
                                    }}
                                    readOnly
                                    type="text"
                                />
                                <Tooltip placement="topLeft" title={messCopied}>
                                    <div className="clip-path" onClick={copyClipBoard}>
                                        <div
                                            style={{
                                                padding: "0 3px 3px 0",
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: 18,
                                                height: 18,
                                                backgroundColor: "white",
                                                zIndex: 1,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    border: "1px #646464 solid",
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor: "white",
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                border: "1px #646464 solid",
                                                position: "absolute",
                                                bottom: 0,
                                                right: 0,
                                                width: 15,
                                                height: 15,
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                        <div style={{ marginTop: 30 }}>
                            <ModuleButtonAction
                                className="submit-btn"
                                type="primary"
                                text={t("page.action.save")}
                                onClick={() => props.handleClose()}
                            />
                        </div>
                    </div>
                );
            case MODAL_PERMISSION_EDIT:
                return (
                    <div
                        className="wrap-btn"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            marginTop: 24,
                            paddingTop: 24,
                            borderTop: "1px #A5A5A5 solid",
                        }}
                    >
                        <p style={{ alignSelf: "start" }}>
                            {t("page.permission.edit_permissions_granted_to_this_account_member")}
                        </p>
                        <div style={{ width: "100%" }}>
                            <Select
                                style={{ width: "80%", height: 48, margin: "8px 0px" }}
                                placeholder={t("page.permission.choose_permission")}
                                onChange={(value: SetStateAction<string>) => setValueSelect(value)}
                                defaultValue={currentRole.name}
                            >
                                {listRole &&
                                    listRole.map((item) => {
                                        if (item._id !== currentRole.roleId)
                                            return (
                                                <Option key={item._id} value={item._id}>
                                                    <Radio
                                                        checked={valueSelect === item._id}
                                                        value={item._id}
                                                    >
                                                        {item.name}
                                                    </Radio>
                                                </Option>
                                            );
                                    })}
                            </Select>
                        </div>
                        <p onClick={() => handleDelete()} className="delete-field">
                            {t("page.permission.delete_this_account_member")}
                        </p>
                        <div style={{ marginTop: 30 }}>
                            <ModuleButtonAction
                                className="submit-btn"
                                type="primary"
                                text={t("page.action.save")}
                                onClick={() => updateRole(valueSelect)}
                            />
                        </div>
                    </div>
                );
        }
    };
    const titleModal = () => {
        switch (props.typeModal) {
            case MODAL_PERMISSION_ADD:
                return t("page.permission.add_member");
            case MODAL_PERMISSION_EDIT:
                return t("page.permission.manage_permissions");
            case MODAL_PERMISSION_INFO:
                return t("page.permission.permission_types");
        }
    };
    return (
        <Modal
            centered
            visible={props.visible}
            onCancel={() => props.handleClose()}
            footer={null}
            title={titleModal()}
        >
            <div></div>
            <Container>
                <div>
                    <div className="title flex-row">
                        <div className="flex" style={{ flex: 2 }}></div>
                        {listRole.map((item) => (
                            <div key={item._id} className="flex" style={{ flex: 1 }}>
                                {item.name}
                            </div>
                        ))}
                    </div>
                    {permissionTitle.map((item, index) => (
                        <div
                            key={index}
                            className={
                                !(index % 2) ? "flex-row bg-transparent" : "flex-row bg-gray"
                            }
                        >
                            <div
                                className="flex"
                                style={{
                                    flex: 2,
                                    display: "flex",
                                    justifyContent: "start",
                                    paddingLeft: "22px",
                                }}
                            >
                                <div className="type-permission-text">{item.title}</div>
                            </div>

                            {listRole.map((rolteItem, roleIndex) => (
                                <div
                                    key={roleIndex}
                                    className="flex"
                                    style={{ flex: 1, order: roleIndex }}
                                >
                                    {rolteItem.permissions.map((rolePermission) =>
                                        rolePermission === item.type ? activeIcon : <></>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                {actionField(props.typeModal)}
            </Container>
        </Modal>
    );
};

const Container = styled.div`
    .flex-row {
        display: flex;
        min-height: 66px;
        align-items: center;
    }
    .title {
        font-weight: 700;
        font-size: 16px;
        color: black;
        background-color: #e1e1e1;
    }
    .bg-transparent {
        background-color: transparent;
    }
    .bg-gray {
        background-color: #f7f7f8;
    }
    .flex {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .type-permission-text {
        color: #646464;
        font-weight: 16px;
    }
    .wrap-btn {
        button {
            min-width: 118px;
            min-height: 49px;
            font-weight: 600;
            font-size: 16px;
        }
    }
    .ant-select-selection-selected-value {
        margin-top: 8px;
    }
    .ant-select-selection__rendered {
        height: 100%;
    }
    .clip-path {
        width: 21px;
        height: 21px;
        position: relative;
        cursor: pointer;
        &:hover {
            opacity: 0.8;
        }
        &:active {
            transform: scale(0.95);
        }
    }
    .ant-select-selection__placeholder,
    .ant-select-search__field__placeholder {
        color: #646464 !important;
    }
    .delete-field {
        align-self: flex-start;
        color: #f22f46;
        cursor: pointer;
        text-decoration: underline;
    }
`;
